import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Advantage from './components/Advantage';
import ServiceScope from './components/ServiceScope';
import ReviewDemo from './components/ReviewDemo';
import Pricing from './components/Pricing';
import ContactCTA from './components/ContactForm';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO, getBaseUrl } from '../../utils/seo';

export default function HomePage() {
  const baseUrl = getBaseUrl();
  
  useSEO({
    title: 'Asher Reviews - Mac Game Testing by a Real 12-Year-Old Gamer',
    description: 'Don\'t guess what 11-13 year olds want - ask one. Professional Mac game reviews and playtesting from Asher, a real 12-year-old gamer. Get authentic feedback on gameplay, fun factor, and difficulty for your target demographic.',
    keywords: 'Mac game reviews, game testing, 12-year-old gamer, indie game feedback, Mac gaming',
    canonical: `${baseUrl}/`,
    ogTitle: 'Asher Reviews - Mac Game Testing by a Real 12-Year-Old',
    ogDescription: 'Real feedback from a real gamer in your target demographic. Mac games only.',
    ogType: 'website',
    ogUrl: `${baseUrl}/`,
    ogImage: 'https://public.readdy.ai/ai/img_res/375bb81103153a786f4c0e0b88873968.jpg',
    twitterTitle: 'Asher Reviews - Mac Game Testing',
    twitterDescription: 'Don\'t guess what 11-13 year olds want - ask one.',
    twitterImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20and%20energetic%20gaming%20setup%20featuring%20a%20modern%20Mac%20computer%20with%20colorful%20RGB%20lighting%2C%20gaming%20controller%2C%20and%20headphones%20on%20a%20clean%20desk.%20The%20scene%20shows%20a%20young%20gamers%20workspace%20with%20game%20screenshots%20on%20the%20monitor%2C%20achievement%20badges%2C%20and%20gaming%20posters%20on%20the%20wall.%20Professional%20yet%20youthful%20atmosphere%20with%20teal%20and%20orange%20accent%20colors%2C%20high-quality%20photography%20style%2C%20bright%20and%20inviting%20lighting%2C%20shallow%20depth%20of%20field&width=1200&height=630&seq=asher-twitter-main&orientation=landscape',
    twitterCard: 'summary_large_image',
    structuredData: [
      {
        '@context': 'https://schema.org',
        '@type': 'ProfessionalService',
        name: 'Asher Reviews',
        description: 'Professional Mac game reviews and playtesting from a real 12-year-old gamer',
        url: baseUrl,
        logo: `${baseUrl}/vite.svg`,
        image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20and%20energetic%20gaming%20setup%20featuring%20a%20modern%20Mac%20computer%20with%20colorful%20RGB%20lighting%2C%20gaming%20controller%2C%20and%20headphones%20on%20a%20clean%20desk.%20The%20scene%20shows%20a%20young%20gamers%20workspace%20with%20game%20screenshots%20on%20the%20monitor%2C%20achievement%20badges%2C%20and%20gaming%20posters%20on%20the%20wall.%20Professional%20yet%20youthful%20atmosphere%20with%20teal%20and%20orange%20accent%20colors%2C%20high-quality%20photography%20style%2C%20bright%20and%20inviting%20lighting%2C%20shallow%20depth%20of%20field&width=1200&height=630&seq=asher-schema-main&orientation=landscape',
        priceRange: '$$$',
        areaServed: 'Worldwide',
        serviceType: 'Game Testing and Reviews',
        audience: {
          '@type': 'Audience',
          audienceType: 'Game Developers'
        }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Asher Reviews',
        url: baseUrl,
        description: 'Professional Mac game reviews and playtesting from a real 12-year-old gamer',
        publisher: {
          '@type': 'Organization',
          name: 'Asher Reviews'
        }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Asher Reviews',
        url: baseUrl,
        logo: `${baseUrl}/vite.svg`,
        description: 'Mac game testing and reviews by a real 12-year-old gamer',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'Customer Service',
          availableLanguage: 'English'
        }
      }
    ]
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1a1a1d] to-[#0d0d0f]">
      <Header />
      <Hero />
      <Advantage />
      <ServiceScope />
      <ReviewDemo />
      <Pricing />
      <ContactCTA />
      <Footer />
    </div>
  );
}
